import styled, { css } from 'styled-components'
import tw from 'twin.macro'

const TableWrapper = styled.div`
	width: 100%;
	overflow-y: auto;
	overflow-x: auto;

	scrollbar-width: none;
	&::-webkit-scrollbar {
		display: none;
	}

	@media screen and (max-width: 960px) {
		flex-direction: column;
	}
`

const Table = styled.table`
	overflow: visible;
	${() => tw`table table-auto w-full`}
`

const Row = styled.tr`
	color: ${(props) => (props.header?.secondary || props.theme.color)};
	text-align: ${(props) => props.textAlign};
	font-size: ${(props) => (props.header ? '0.95rem' : '20px')};
	transition: all 0.3s ease;
	background-color: ${(props) => props.theme.tableRowBg};

	/* &:nth-child(even) {
	} */
	${(props) =>
		`
		&:hover {
		transform: scale(1.03) translateY(-4px);
		}
	`}
`;

export const DIV = styled.div`
	text-align: ${(props) => props.textAlign};
	font-weight: ${(props) => props.header && 600};
	font-size: ${(props) => props.header && '0.95rem'};
	color: ${(props) => (props.header && props.header.secondary) || props.theme.color};

	${() => tw`p-2`}
`

export const TD = styled.td`
	text-align: ${(props) => props.textAlign};
	font-weight: ${(props) => props.header && 600};
	font-size: ${(props) => props.header && '0.8	rem'};
	color: ${(props) => (props.header && props.header.secondary) || props.theme.color};
	&:nth-child(even) {
		background-color: ${(props) => props.theme.bg_second};
	}

	${() => tw`p-4`};

	@media screen and (max-width: 768px) {
		font-size: 0.8rem;
	}
`

export const TH = styled.td`
	color: ${(props) => props.theme.secondary};
	font-weight: 600;
	font-size: ${(props) => props.fontSize || '0.9rem'};

	${() => tw`p-3 whitespace-nowrap`};

	@media screen and (max-width: 768px) {
		font-size: 0.8rem;
	}
`

const HeaderRow = styled.tr`
	color: ${(props) => props.theme.secondary};
	background-color: ${(props) => props.theme.tableHeaderBg};
	padding: 8px;
`

const HeaderColumn = styled.td`
	color: ${(props) => props.theme.color};
	padding: 16px 10px;
	text-align: center;
	font-size: ${(props) => props.fontSize || '16px'};
	opacity: 80%;
	text-transform: capitalize;

	&:first-child {
		border-radius: ${(props) => props.theme.english ? "16px 0 0 16px" : "0 16px 16px 0"};
	}
	&:last-child {
		border-radius: ${(props) => props.theme.english ? "0 16px 16px 0" : "16px 0 0 16px"};
	}

	@media screen and (max-width: 480px) {
		font-size: 0.9rem;
		padding: 8px;
	}
`

const Column = styled.td`
	transition: all 0.3s;
	padding: 12px 10px;
	color: ${(props) => props.theme.textColor};
	text-align: center;
	font-size: ${(props) => (props.bold && '1.1rem') || '16px'};
	position: relative;
	&:first-child {
		border-radius: ${(props) => props.theme.english ? "16px 0 0 16px" : "0 16px 16px 0"};
	}
	&:last-child {
		border-radius: ${(props) => props.theme.english ? "0 16px 16px 0" : "16px 0 0 16px"};
	}
	@media screen and (max-width: 480px) {
		font-size: 0.8rem;
		padding: 12px 8px;
	}
`

const NoDataWrapper = styled.div`
	display: flex;
	position: absolute;
	top: ${(props) => props.top || '300px'};
	width: 100%;
	left: 0;
	text-align: center;
	justify-content: center;
`

export { TableWrapper, Table, HeaderRow, Row, HeaderColumn, Column, NoDataWrapper }
